import type { Permission } from '@ztechapps/common.contract'

export const haulerPermissions = {
  canAccess: {
    value: 'hauler.canAccess',
    label: 'Can Access',
    description: 'Allows the user to access the hauler application.',
  } satisfies Permission,
}
